import React from "react";
import { Link } from "react-router-dom";

function PayError() {
  return (
    <div className="container-lg p-0 d-flex flex-column flex-sm-row justify-content-center align-items-center my-5">
      <div className="text-center">
        <img
          src="https://cdn-icons-png.flaticon.com/512/564/564619.png"
          alt="Error"
          width="100"
          height="100"
          className="mb-4"
        />
        <h2 className="mb-3 text-danger">Hoppá, valami hiba történt!</h2>
        <p className="lead">
          A rendelés leadása sikertelen volt technikai okok miatt. Lehet, hogy megszakadt az internetkapcsolat, vagy szerverhiba lépett fel.
        </p>
        <p>
          Kérjük, próbáld meg újra néhány perc múlva. Ha a probléma továbbra is fennáll, vedd fel velünk a kapcsolatot.
        </p>
        <div className="d-flex justify-content-center gap-3 mt-4">
          <Link to="/basket" className="btn btn-home-primary">
            Vissza a kosárhoz
          </Link>
          <Link to="/" className="btn btn-outline-secondary">
            Vissza a főoldalra
          </Link>
        </div>
      </div>
    </div>
  );
}

export default PayError;
